<template>
  <section class="page-body">

    <div class="page-title-bar sticky">
      <h1>{{ title }}</h1>

      <router-link :to="{ name: 'AddEvent' }" tag="button" class="btn" title="Add Event">
        <i class="fa-thin fa-plus-circle"></i>
        Add Event
      </router-link>
    </div>
    
    <div class="content-panel">
      <div class="panel-body no-title">
        <div class="data-table">
          <div class="data-table-search">
              <div class="actions">
                <span class="search-icon"><i class="fa-thin fa-search"></i></span>
                <input class="search-input" type="text" :placeholder="'Search Events'" v-model="tableSearchTerm" />
              </div>
          </div>

          <vue-good-table
              :columns="columns"
              :rows="gridList"
              @on-row-click="viewPage"
              styleClass="vgt-table bookings-table"
              :sort-options="{
                  enabled: true,
                  initialSortBy: {field: 'startDate', type: 'desc'}
              }"

              :search-options="{
                  enabled: true,
                  skipDiacritics: true,
                  externalQuery: tableSearchTerm
              }"

              :pagination-options="{
                  enabled: true,
                  mode: 'records',
                  perPage: 50,
                  position: 'bottom',
                  dropdownAllowAll: false,
                  nextLabel: 'next',
                  prevLabel: 'prev',
                  rowsPerPageLabel: 'Rows per page',
                  ofLabel: 'of',
                  pageLabel: 'page', // for 'pages' mode
                  allLabel: 'All',
              }"
          >

              <template slot="table-row" slot-scope="props">
                  <a :title="props.row.name" v-if="props.column.field == 'name'">
                    <strong>{{ props.row.name }}</strong>
                  </a>
                  <span v-if="props.column.field == 'numberOfShows' && props.row.shows">
                    {{ props.row.shows.length }}
                  </span>
                  <span v-if="props.column.field == 'startDate' && props.row.startDate">
                    {{ props.row.startDate | moment("ddd, MMM Do, YYYY") }}
                  </span>
                  <span v-if="props.column.field == 'endDate' && props.row.endDate">
                    {{ props.row.endDate | moment("ddd, MMM Do, YYYY") }}
                  </span>
                  
              </template>

          </vue-good-table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Events',
  data() {
    return {
      title: 'All Events',
      tableSearchTerm: '',
      columns: [
        {
          label: 'Name',
          field: 'name',
          tdClass: 'title-col',
        },
        {
          label: 'Start Date',
          field: 'startDate'
        },
        {
          label: 'End Date',
          field: 'endDate'
        },
        {
          label: 'Number of Shows',
          field: 'numberOfShows'
        }
      ]
    }
  },

  computed: {
    ...mapGetters({
        db : 'db',
        gridList: 'getEventsData'
    })
  },

  metaInfo: {
    title: 'All Events'
  },

  async mounted() {
    let self = this;
    self.getGridData();
  },

  methods: {
    getGridData: async function(forceUpdate) {
      let self = this;

      if(!self.gridList.length || forceUpdate) {
        await self.$store.dispatch('bindEventsData');
      }
    },

    viewPage: function(params) {
      let self = this;
      let id = params.row.id;

      self.$router.push({name: 'EditEvent', params:{ref:id}})
    }
  },

  watch: {
    'db': function() {
      let self = this;
      
      self.getGridData(true);
    }
  },
}
</script>
